import React from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
  Row
} from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import SocialSignup from "../../../SocialSignup/LoadableSocialSignup";

function SignupForm(props) {
  const {
    showSignupForm,
    formData,
    signup,
    signupFormSubmitted,
    errors,
    handleSignupForm,
    isSignup,
    showForm,
    onSocialLogin,
    onSocialSignup
  } = props;

  return (
    showSignupForm && (
      <React.Fragment>
        <ToastContainer />
        <div className="Login">
          <section className="login-form mar_pointt">
            {/* Social Login Section */}
            <Row>
              <section id="socialLogin">
                <SocialSignup
                  onResponse={res => onSocialSignup(res)}
                  signIn={true}
                />
              </section>
            </Row>

            <Row>
              <form onSubmit={signup} id="signup-form" method="post">
                <FormGroup
                  controlId="fullName"
                  className="signup-field"
                  validationState={
                    signupFormSubmitted
                      ? errors.fullName
                        ? "error"
                        : "success"
                      : null
                  }
                >
                  <ControlLabel>Full Name</ControlLabel>
                  <FormControl
                    className="field"
                    type="text"
                    name="txtFullName"
                    // placeholder="Full Name"
                    onChange={handleSignupForm}
                  />
                  {errors.fullName && <HelpBlock>{errors.fullName}</HelpBlock>}
                </FormGroup>
                <FormGroup
                  className="signup-field"
                  controlId="signupEmail"
                  validationState={
                    signupFormSubmitted
                      ? errors.signupEmail
                        ? "error"
                        : "success"
                      : null
                  }
                >
                  <ControlLabel>Email</ControlLabel>
                  <FormControl
                    className="field"
                    type="text"
                    name="txtSignupEmail"
                    // placeholder="Email Address"
                    onChange={handleSignupForm}
                  />
                  {errors.signupEmail && (
                    <HelpBlock>{errors.signupEmail}</HelpBlock>
                  )}
                </FormGroup>
                <FormGroup
                  className="signup-field"
                  controlId="signupPassword"
                  validationState={
                    signupFormSubmitted
                      ? errors.signupPassword
                        ? "error"
                        : "success"
                      : null
                  }
                >
                  <ControlLabel className="labelpassword">
                    Password
                  </ControlLabel>
                  <FormControl
                    className="field"
                    type="password"
                    name="txtSignupPassword"
                    // placeholder="Password"
                    onChange={handleSignupForm}
                  />
                  {errors.signupPassword && (
                    <HelpBlock>{errors.signupPassword}</HelpBlock>
                  )}
                </FormGroup>
                <FormGroup
                  className="signup-field"
                  controlId="email"
                  validationState={
                    signupFormSubmitted
                      ? errors.companyName
                        ? "error"
                        : "success"
                      : null
                  }
                >
                  <ControlLabel>Company Name</ControlLabel>
                  <FormControl
                    className="field"
                    type="text"
                    name="txtCompanyName"
                    // placeholder="Company Name"
                    onChange={handleSignupForm}
                  />
                  {errors.companyName && (
                    <HelpBlock>{errors.companyName}</HelpBlock>
                  )}
                </FormGroup>
                <FormGroup
                  className="signup-field region-field"
                  controlId="region"
                  validationState={
                    signupFormSubmitted
                      ? errors.companyName
                        ? "error"
                        : "success"
                      : null
                  }
                  // style={{ display: "none" }}
                >
                  <ControlLabel>Data Center</ControlLabel>

                  <select
                    className="company-region field"
                    name="txtCompanyRegion"
                    defaultValue={formData["region"]}
                    // defaultValue={"US"}
                    onChange={handleSignupForm}
                  >
                    {/* <option selected={true} disabled="disabled">
                      Select Data Center
                    </option> */}
                    <option value="US">US</option>
                    <option value="EU">EU</option>
                    <option value="IN">IN</option>
                    <option value="AU">AU</option>
                  </select>

                  {errors.region && <HelpBlock>{errors.region}</HelpBlock>}
                </FormGroup>

                <Button
                  type="submit"
                  className="btn-style signup-submit"
                  disabled={isSignup}
                >
                  {isSignup ? "Signing Up..." : "Sign Up"}
                </Button>
              </form>
            </Row>
          </section>
        </div>
        <div className="signup-form">
          <section id="TermsAndConditions">
            <span>
              Already have an account?{" "}
              <a href="#/">
                <span onClick={env => showForm("login")} className="signLink">
                  Sign in
                </span>
              </a>
            </span>
          </section>
        </div>
      </React.Fragment>
    )
  );
}

export default SignupForm;



// WEBPACK FOOTER //
// ./src/components/Login/SubComponents/SignupForm/SignupForm.js